export default __webpack_public_path__ + "static/media/viacerta-logo.d1fba15e.svg";